import defaultState from './state'
import Vue from 'vue'

export default {
  setCards: (state, payload) => {
    if (state.currentPage === 1) {
      state.cards = payload
    } else {
      state.cards.push(...payload)
    }
  },
  setIsCallingCards: (state, payload) => {
    state.isCallingCards = payload
  },
  setCardsLastPage: (state, payload) => {
    state.lastPage = payload
  },
  setCardsTotalItems: (state, payload) => {
    state.totalItems = payload
  },
  setCardsFilters: (state, payload) => {
    state.filters = payload
    state.currentPage = 1
  },
  updateCard (state, payload) {
    const cardToUpdateIndex = state.cards.findIndex(el => el.id === payload.id)
    if (cardToUpdateIndex !== -1) {
      state.cards.splice(cardToUpdateIndex, 1, payload)
    } else {
      state.cards.push(payload)
    }
  },
  incrementCardsCurrentPage: state => state.currentPage++,
  setLoadingCards: (state, payload) => {
    state.isLoadingCards = payload
  },
  setLoadingNextPageCards: (state, payload) => {
    state.isLoadingNextPageCards = payload
  },
  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }

}
